import { useStyle } from '@/classify';
import { useSearchBar } from '@/hooks/SearchBar/useSearchBar';
import { Form } from 'informed';
import { useRouter } from 'next/navigation';
import React, { useEffect, useState } from 'react'; // 添加 useState 和 useEffect
import Autocomplete from './autocomplete';
import { PopularSearches } from './popular-searches';
import defaultClasses from './searchBar.module.css';
import SearchField from './searchField';

const SearchBar = React.forwardRef((props, ref) => {
  const { isOpen, afterSubmit, showPoplarSearches = true, showAutoComplete = true } = props;
  const talonProps = useSearchBar(props);
  const {
    containerRef,
    handleChange,
    handleFocus,
    handleSubmit,
    initialValues,
    isAutoCompleteOpen,
    setIsAutoCompleteOpen,
    valid,
    searchValue,
  } = talonProps;

  const [isClient, setIsClient] = useState(false); // 添加 isClient 状态
  const router = useRouter();
  
  // 添加 useEffect 来设置 isClient 状态
  useEffect(() => {
    setIsClient(true);
  }, []);

  const classes = useStyle(defaultClasses, props.classes);
  const rootClassName = isOpen ? classes.root_open : classes.root;
  const maybeAutoComplete =
    isAutoCompleteOpen && showAutoComplete ? (
      <div className={classes.autocomplete}>
        <Autocomplete
          setVisible={setIsAutoCompleteOpen}
          valid={valid}
          afterSubmit={afterSubmit}
          visible={isAutoCompleteOpen}
          searchValue={searchValue}
        />
      </div>
    ) : null;
  const handleSubmitSearch = params => {
    handleSubmit({ values: params });
  };
  
  // 修改 onPopularSearchClick 函数，确保只在客户端执行路由跳转
  const onPopularSearchClick = searchQuery => {
    if (isClient) {
      router.push(`/search.html?query=${searchQuery}`);
    }

    afterSubmit();
  };

  return (
    <div
      className={rootClassName}
      ref={ref}
    >
      <div
        ref={containerRef}
        className={classes.container}
      >
        <Form
          autoComplete='off'
          className={classes.form}
          initialValues={initialValues}
          onSubmit={handleSubmit}
        >
          <div className={classes.search}>
            <SearchField
              classes={{
                root: 'lg_pr-[40px] pr-[30px]',
              }}
              isSearchOpen={isOpen}
              onChange={handleChange}
              onFocus={handleFocus}
              onSubmit={handleSubmitSearch}
            />
          </div>
          {showPoplarSearches && <PopularSearches onPopularSearchClick={onPopularSearchClick} />}
          {maybeAutoComplete}
        </Form>
      </div>
    </div>
  );
});

export default SearchBar;
